module.exports = __webpack_public_path__ + "static/media/campus_21.74204ddd.png";